import { dateConvert, renderField } from "../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormTable } from "../../Hooks/Features/WelcomeKit/useFormTable";
import { useEffect } from "react";
import CommanDialog from "../CommonCompo/CommanDialog/CommanDialog";

function FormTable({ onPrev, onNext, readOnly, label, data, fieldsDetails, IsTitle, notTable, handleAPI, row, familyList }) {

  const { handleDelete, handleSave, handleChange, handleReset, handleEdit, rows, fieldData, formValues, editIndex, formErrors, getFieldDataWithOptions, familyData, updatedFieldData, setUpdatedFieldData, exportToExcel, showPopup, setShowPopup } = useFormTable({ label, fieldsDetails, data, handleAPI, row, familyList });

  useEffect(() => {
    const updatedField = getFieldDataWithOptions(fieldData, rows, familyData);
    setUpdatedFieldData(updatedField)

  }, [fieldData, rows, familyData])

  return (
    <div className="pb-4 w100">
      <form>
        {Object.entries(updatedFieldData).map(([section, fields]) => (
          <div key={section} className="my-2">
            {
              IsTitle !== "no" && <h4 className="p-2" style={{ background: "#f2f2f2" }}>{section}</h4>
            }
            {fields?.otherText && <div className='d-flex justify-content-between'>
              <div><span><b>Employee Name: </b>{data?.employee?.user_display_name}</span></div>
              <div><span><b>Employee Id: </b>{data?.employee?.employee_id}</span></div>
              <div><span><b> Employee Date of Joining: </b> {dateConvert(data?.employee?.joining_date, "day-mon-year")}</span></div>
            </div>}
            {
              !readOnly && <>
                <div className="row px-0 mx-0">
                  {fields?.inputs?.map((value, index) => {
                    if (value.depand && !formValues[section]?.[value.depand]) return null;
                    return renderField(
                      value,
                      index,
                      e => handleChange(section, e),
                      formValues[section] || {},
                      formErrors[section] || {}
                    )
                  }
                  )}

                </div>
                <div className="d-flex gap-2 justify-content-end mb-2">
                  <button className="btn btn-default fw-bold" onClick={e => handleReset(section, e)}>Reset</button>
                  <button className="btn btn-primary fw-bold" onClick={e => handleSave(section, e)}>
                    {editIndex[section] !== null && editIndex[section] !== undefined ? "Update" : "Save"}
                  </button>
                </div>
              </>
            }

            {
              !notTable && <div className="my-3 px-3">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      {fields.inputs?.filter(field => !field?.fieldHide)?.map(field =>
                        (!readOnly || (readOnly && field?.type !== "file")) && <th key={field.name}>{field.label}</th>
                      )
                      }
                      {
                        !readOnly && <th>Action</th>
                      }
                    </tr>
                  </thead>

                  {rows[section] && rows[section].length > 0 && (
                    <tbody>
                      {rows[section] && rows[section].length > 0 && rows[section].map((row, idx) => (
                        <tr key={idx}>
                          {fields?.inputs
                            ?.filter(field => !field?.fieldHide)
                            .map(field => (
                              field?.type === "file" ? <>
                                {
                                  !readOnly && <td key={field.name}>
                                    <img src={row[`${field.name}_id`]} width={50} height={50} alt="" />
                                  </td>
                                }
                              </> : (
                                <td key={field.name}>
                                  {typeof row[field.name] === 'boolean'
                                    ? row[field.name] ? 'Yes' : 'No'
                                    : field?.type?.includes('month')
                                      ? `${new Date(row[field.name]).getMonth() + 1}/${new Date(row[field.name]).getFullYear()}`
                                      : (field?.type?.includes('year') && typeof row[field?.name] === "object")
                                        ? `${new Date(row[field.name]).getFullYear()}`
                                        : field?.type?.includes('date')
                                          ? dateConvert(row[field.name])
                                          : field?.type === "select"
                                            ? row[field?.tableField]
                                            : field?.name === "date_of_birth"
                                              ? dateConvert(row[field.name], "day-mon-year")
                                              : row[field.name]
                                  }
                                </td>

                              )
                            ))
                          }
                          {
                            !readOnly && <td className="d-flex justify-content-center gap-2">
                              {
                                !fieldData[section]?.is_dynamic && (
                                  <FontAwesomeIcon
                                    icon="fas fa-edit"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleEdit(section, idx)}
                                  />
                                )
                              }
                              <FontAwesomeIcon
                                icon="fa-solid fa-trash"
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowPopup({ visibel: true, section, row, idx })}
                              />
                            </td>
                          }

                        </tr>
                      ))}
                    </tbody>
                  )}
                </table>
              </div>
            }
            {
              fields?.download && !readOnly && <div className="d-flex gap-2 justify-content-end my-3">
                <button className="btn btn-default" onClick={exportToExcel} type="button">
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-arrow-down"
                  />  Excel
                </button>
              </div>
            }
          </div>
        ))}
      </form>

      {
        !fieldsDetails && !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
          <button className='btn-default' onClick={onPrev}>Previous</button>
          <button className='btn-primary' onClick={onNext}>Proceed</button>
        </div>
      }
      <CommanDialog visible={showPopup?.visibel} message={"Are you sure you want to delete this?"} handleClose={() => setShowPopup({
        visibel: false,
        section: "",
        idx: "",
        row: ""
      })} handleFun={() => handleDelete(showPopup?.section, showPopup?.row, showPopup?.idx)} />
    </div>
  );
}
export default FormTable;
